export const getRandomInt = (to) => {
  return Math.round(Math.random() * to);
};
